import React, { useState } from 'react';
import I18n from 'i18n-js';
import { core_apimessages_Address as Address } from '@reverbdotcom/commons/src/gql/graphql';
import { RCButton, RCRadioCardGroup } from '@reverbdotcom/cadence/components';
import AddressSummary from '../AddressSummary';
import { ErrorAlertBox } from '@reverbdotcom/commons/src/ErrorAlertBox';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';
import { gql } from '@reverbdotcom/commons/src/gql';

interface Props {
  address: Address;
  onAddressUpdated: () => void;
  suggestion: Address;
}

export function AddressSuggestionForm(props: Props) {
  const { address, onAddressUpdated, suggestion } = props;
  const [radioValue, setRadioValue] = useState('suggestion');
  const [mutate, { errors }] = useMutation(ACCEPT_SUGGESTION_MUTATION);

  async function submit(e: React.ChangeEvent<HTMLFormElement>) {
    e.preventDefault();

    if (radioValue === 'default') {
      onAddressUpdated();
    }

    await mutate({
      variables: {
        input: {
          id: address.id,
        },
      },
    });

    onAddressUpdated();
  }

  return (
    <form onSubmit={submit}>
      {errors.length > 0 &&
        <div className="mb-2">
          <ErrorAlertBox errors={errors} />
        </div>
      }
      <RCRadioCardGroup
        id="radioGroupId"
        label={I18n.t('discovery.addressSuggestion.form.label')}
        name="address-suggestion-form"
        onChange={e => { setRadioValue(e.target.value); }}
        value={radioValue}
      >
        <RCRadioCardGroup.Option
          label={I18n.t('discovery.addressSuggestion.form.recommended')}
          value="suggestion"
        >
          <AddressSummary address={suggestion} />
        </RCRadioCardGroup.Option>
        <RCRadioCardGroup.Option
          label={I18n.t('discovery.addressSuggestion.form.whatYouEntered')}
          value="default"
        >
          <AddressSummary address={address} />
        </RCRadioCardGroup.Option>
      </RCRadioCardGroup>
      <div className="d-flex fx-justify-end fx-wrap gap-2">
        <RCButton
          onClick={onAddressUpdated}
          variant="muted"
        >
          {I18n.t('discovery.addressSuggestion.form.cancel')}
        </RCButton>
        <RCButton
          isSubmit
          variant="filled"
        >
          {I18n.t('discovery.addressSuggestion.form.save')}
        </RCButton>
      </div>
    </form>
  );
}

const ACCEPT_SUGGESTION_MUTATION = gql(`
  mutation Core_Accept_Suggestion(
    $input: Input_core_apimessages_AcceptSuggestionRequest
  ) {
    acceptSuggestion(input: $input) {
      id
    }
  }
`);
